var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPillar1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.8,
    height: 69.4,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st0",
    d: "M50 8.1c-.6-.4-1.5-.3-1.9.4-.4.6-.3 1.5.4 1.9C57 15.9 62 25.3 62 35.3 62 51.7 48.8 65 32.4 65c-3.7 0-7.5-.7-10.9-2.1l1.9-.4c.8-.2 1.2-1 1-1.6-.2-.8-.9-1.2-1.6-1l-5.9 1.4c-.4.1-.8.3-1 .8V62c-.2.3-.2.8 0 1.2l2.8 5.4c.3.4.7.8 1.2.8.2 0 .4-.1.6-.2.7-.3 1-1.2.6-1.8l-1-1.9c3.9 1.6 8.1 2.4 12.2 2.4 17.9 0 32.4-14.6 32.4-32.4.1-11.2-5.4-21.4-14.7-27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    className: "st0",
    d: "M2.8 35.3C2.8 19 16.1 5.7 32.4 5.7c2.4 0 4.9.3 7.2.9l-1.7.7c-.7.3-1 1-.8 1.8.2.5.7.9 1.3.9.2 0 .3 0 .5-.1l5.6-2.2c.4-.2.7-.5.8-.9v-.1-.1c.1-.3.1-.8-.2-1.2L41.5.5c-.5-.5-1.3-.7-2-.3-.6.4-.8 1.3-.3 1.9L40.6 4c-2.7-.7-5.4-1-8.2-1C14.6 2.9 0 17.5 0 35.3c0 9.6 4.2 18.7 11.7 25 .3.2.6.3.9.3.4 0 .8-.2 1-.5.5-.6.4-1.5-.2-1.9-6.7-5.7-10.6-14-10.6-22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M44.8 25.4c-1.7-1.7-3.8-2.5-6-2.5s-4.4.8-6 2.5l-.4.5-.4-.4c-1.7-1.7-3.8-2.5-6-2.5s-4.4.8-6 2.5c-3.3 3.3-3.3 8.8 0 12.1l12.4 12.3 12.4-12.4c3.4-3.4 3.4-8.8 0-12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st0",
    d: "M20.5 54.1c-.6-.4-1.5-.3-1.9.4l-1.5 2.3c-.4.6-.3 1.5.4 1.9.3.2.5.2.8.2.4 0 .9-.3 1.1-.6l1.5-2.3c.4-.6.2-1.5-.4-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M9.1 49.1c.3 0 .4-.1.6-.2l2.5-1.3c.7-.3 1-1.2.6-1.9s-1.2-1-1.9-.6l-2.5 1.3c-.7.3-1 1.2-.6 1.9.3.6.8.8 1.3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M8.8 36.1c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4L6 33.2c-.8 0-1.4.6-1.4 1.4S5.3 36 6.1 36l2.7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M13.3 23.9c.4-.7.2-1.5-.4-1.9l-2.4-1.5c-.7-.4-1.5-.1-1.9.5-.4.7-.2 1.5.4 1.9l2.4 1.5c.3.2.4.2.7.2.6 0 1-.3 1.2-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st0",
    d: "M22 14.1l-1.4-2.4c-.3-.7-1.2-.9-1.9-.5s-.9 1.2-.5 1.9l1.4 2.4c.3.4.7.7 1.2.7.3 0 .4-.1.7-.2.6-.3.9-1.2.5-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M32.4 13.2c.8 0 1.4-.6 1.4-1.4V9c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4v2.8c0 .8.6 1.4 1.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st0",
    d: "M31 58.9v2.8c0 .8.6 1.4 1.4 1.4.8 0 1.4-.6 1.4-1.4v-2.8c0-.8-.6-1.4-1.4-1.4-.8 0-1.4.6-1.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st0",
    d: "M44.2 11.7l-1.4 2.4c-.3.7-.2 1.5.5 1.9.2.1.4.2.7.2.5 0 1-.3 1.2-.7l1.4-2.4c.3-.7.2-1.5-.5-1.9-.7-.4-1.5-.2-1.9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st0",
    d: "M54.3 20.6l-2.4 1.5c-.7.4-.9 1.2-.4 1.9.3.4.7.7 1.2.7.3 0 .5-.1.7-.2l2.4-1.5c.7-.4.9-1.2.4-1.9-.4-.7-1.3-.9-1.9-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st0",
    d: "M60.1 34.6c0-.8-.7-1.4-1.4-1.4l-2.7.2c-.8 0-1.4.7-1.4 1.4 0 .8.6 1.4 1.4 1.4l2.8-.1c.8-.1 1.4-.7 1.3-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M53.9 45.2c-.7-.3-1.5-.1-1.9.6-.3.7-.1 1.5.6 1.9l2.5 1.3c.2.1.4.2.6.2.5 0 1-.3 1.2-.7.3-.7.1-1.5-.6-1.9l-2.4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M44.4 54.1c-.6.4-.9 1.3-.4 1.9l1.5 2.3c.3.4.7.6 1.1.6.3 0 .5-.1.8-.2.6-.4.9-1.3.4-1.9l-1.5-2.3c-.5-.6-1.3-.8-1.9-.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillar1);
export default __webpack_public_path__ + "static/media/pillar1.f753d4314bd8b66328ee2cead171002d.svg";
export { ForwardRef as ReactComponent };